import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'noDeadlinesCard',
    'card',
    'calendarCell',
    'cardItem',
    'typeButton',
    'taxReturn',
    'salary',
    'valueAddedTax',
    'expired',
  ]

  connect() {
    // Company-type toggle: AS is the default selection (matches its aria-pressed markup).
    this.as = true
    this.updateButtons()
    this.updateCards()
  }

  updateCards() {
    let as = this.as
    let taxReturn = this.taxReturnTarget.checked
    let salary = this.salaryTarget.checked
    let valueAddedTax = this.valueAddedTaxTarget.checked
    let expired = this.expiredTarget.checked

    let filterCondition = (el) => {
      return (
        ((taxReturn && el.attributes['group'].value.includes('Tax return')) ||
          (salary && el.attributes['group'].value.includes('Salary')) ||
          (valueAddedTax && el.attributes['group'].value.includes('VAT'))) &&
        ((as && el.attributes['company-type'].value.includes('AS')) ||
          (!as && el.attributes['company-type'].value.includes('ENK'))) &&
        (expired || new Date().setUTCHours(0, 0, 0, 0) <= Date.parse(el.attributes['date'].value))
      )
    }

    this.cardItemTargets.forEach((type) => {
      type.hidden = true
    })

    this.cardItemTargets
      .filter((el) => filterCondition(el))
      .forEach((el) => {
        el.hidden = false
      })

    this.calendarCellTargets.forEach((el) => {
      if (el.attributes['color-class'].value !== '') {
        el.attributes['color-class'].value.split(' ').forEach((val) => el.classList.remove(val))
      }
    })

    this.calendarCellTargets
      .filter((el) => filterCondition(el))
      .forEach((el) => {
        if (el.attributes['color-class'].value !== '') {
          el.attributes['color-class'].value.split(' ').forEach((val) => el.classList.add(val))
        }
      })

    this.hideEmptyCards()
  }

  // AS / ENK pill toggle (mirrors the help-centre company-type filter, minus "Alle").
  selectType(event) {
    this.as = event.currentTarget.dataset.type === 'as'
    this.updateButtons()
    this.updateCards()
  }

  // Pink pill for the selected company type, muted text for the other.
  updateButtons() {
    this.typeButtonTargets.forEach((btn) => {
      const active = btn.dataset.type === (this.as ? 'as' : 'enk')
      btn.setAttribute('aria-pressed', active ? 'true' : 'false')
      btn.classList.toggle('bg-pink-luca', active)
      btn.classList.toggle('text-content-on-brand', active)
      btn.classList.toggle('shadow-sm', active)
      btn.classList.toggle('text-content-muted', !active)
      btn.classList.toggle('hover:text-content-subtle', !active)
    })
  }

  hideEmptyCards() {
    this.cardTargets.forEach((type) => {
      type.hidden = false
    })

    let cards = []
    this.calendarCellTargets.filter((el) => {
      let hidden = !el.attributes['class'].value.includes(el.attributes['color-class'].value)
      if (el.attributes['color-class'].value == '') {
        hidden = undefined
      }
      cards.push({ key: el.attributes['month'].value, hidden: hidden })
    })

    cards = this.groupBy(cards, (pet) => pet.key)
    let activeCardsCounter = 0
    for (const item of cards.keys()) {
      if (cards.get(item).filter((it) => it.hidden !== undefined && !it.hidden).length === 0) {
        activeCardsCounter += 1
        this.cardTargets
          .filter((card) => card.attributes['month'].value.includes(item))
          .forEach((card) => (card.hidden = true))
      }
    }

    this.noDeadlinesCardTarget.hidden = activeCardsCounter != cards.size
  }

  groupBy(list, keyGetter) {
    const map = new Map()
    list.forEach((item) => {
      const key = keyGetter(item)
      const collection = map.get(key)
      if (!collection) {
        map.set(key, [item])
      } else {
        collection.push(item)
      }
    })
    return map
  }
}
